// * This file patches the hashgraph sdk to which are lost in tree shaking
// ! BUG FROM LIBRARY'S END - This file patches this

import {
  Query,
  Transaction,
  ContractExecuteTransaction,
  ContractCallQuery,
  ContractInfoQuery,
  AccountBalanceQuery,
  AccountInfoQuery,
  TokenAssociateTransaction,
  AccountAllowanceApproveTransaction,
} from "@hashgraph/sdk";

// ? Ensuring _fromBytes maps exist
if (!(Transaction as any)._fromBytes) {
  (Transaction as any)._fromBytes = {};
}
if (!(Query as any)._fromBytes) {
  (Query as any)._fromBytes = {};
}

/**
 * Helper to safely register transaction types
 */
function registerTransactionType(
  type: string,
  handler: (bytes: Uint8Array) => unknown
) {
  const txMap = (Transaction as any)._fromBytes;
  if (!txMap[type]) {
    txMap[type] = handler;
  }
}

/**
 * Helper to safely register query types
 */
function registerQueryType(
  type: string,
  handler: (bytes: Uint8Array) => unknown
) {
  const queryMap = (Query as any)._fromBytes;
  if (!queryMap[type]) {
    queryMap[type] = handler;
  }
}

// * Patch known transaction types
registerTransactionType("contractCall", (bytes) =>
  ContractExecuteTransaction.fromBytes(bytes)
);
registerTransactionType("tokenAssociate", (bytes) =>
  TokenAssociateTransaction.fromBytes(bytes)
);
registerTransactionType("cryptoApproveAllowance", (bytes) =>
  AccountAllowanceApproveTransaction.fromBytes(bytes)
);

// * Patch known query types
registerQueryType("contractCallLocal", (bytes) =>
  ContractCallQuery.fromBytes(bytes)
);
registerQueryType("contractGetInfo", (bytes) =>
  ContractInfoQuery.fromBytes(bytes)
);
registerQueryType("accountBalance", (bytes) =>
  AccountBalanceQuery.fromBytes(bytes)
);
registerQueryType("accountInfo", (bytes) => AccountInfoQuery.fromBytes(bytes));

// * Patch fallback for unknown internal query type (like 'getByKey')
// ? This function doesn't even exist in library, but something is calling it
if (!(Query as any)._fromBytes["getByKey"]) {
  (Query as any)._fromBytes["getByKey"] = () => {
    // eslint-disable-next-line no-console
    console.warn(
      "⚠️ getByKey query used - no official handler. Returning empty query."
    );
    return new AccountInfoQuery(); // fallback
  };
}
